import { api } from "@/shared/api";
import type { TaskBrief } from "../model/taskPolling";

/** PageResponse 包裹(backend `com.gscq.common.api.PageResponse`:records/total/page/size)。 */
export interface PageResult<T> {
  records: T[];
  total: number;
  page: number;
  size: number;
}

const SIZE = 8;

/**
 * 「最近出图/出片」thin api。复用既有 `/poster/tasks`、`/video/tasks`(0-indexed page,mine=true 由后端 DataScope 控)。
 * **不** import `@/features/poster|video`(eslint no-restricted-imports);自带最小投影 `TaskBrief`。
 */
export const creationsApi = {
  listPosters: () => api.get<PageResult<TaskBrief>>(`/poster/tasks?page=0&size=${SIZE}&mine=true`),
  listVideos: () => api.get<PageResult<TaskBrief>>(`/video/tasks?page=0&size=${SIZE}&mine=true`),
};
